<template>
    <div v-if="account != undefined">
        <slot name="prepend"></slot>
        <div class="d-flex">
            <avatar-view :user="account" :size="72" class="mx-2 my-2"></avatar-view>
            <div class="popover-content">
                <p>{{ account.surname }}</p>
                <p>{{ account.name }}</p>
                <p>{{ account.patronymic }}</p>
                <b>{{ account.email || account.uid }}</b>
            </div>
        </div>
        <slot name="append">
            <div v-for="company in companies" :key="company.id">
                <div class="d-flex">
                    <v-icon icon="mdi-domain"></v-icon>
                    <b style="padding-left: 8px;">{{ company.name }}</b>
                    <span style="padding-left: 4px; max-width: 200px;" v-if="company.groups.length > 0">
                        <em>({{ company.groups.join(', ') }})</em>
                    </span>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
import AvatarView from './AvatarView.vue';

export default {
    components: {
        AvatarView,
    },
    name: 'UserDetail',
    props: {
        user: Object,
        id: String,
    },
    computed: {
        account() {
            if (this.user != null) {
                return this.user;
            }
            return this.$api.get_user(this.id);
        },
        companies() {
            const result = [];
            const companies = this.account?.companies;
            const me = this.$api.me;
            if (companies != null) {
                for (let i = 0; i < companies.length; i += 1) {
                    const company = companies[i];
                    const g = [];
                    const obj = {
                        id: company.id,
                        name: company.name,
                        groups: g,
                    };
                    result.push(obj);
                    const groups = company.groups;
                    const admin = me.user.admin;
                    if ((groups != null) && ((admin) || (me.user.id === this.account.id))) {
                        for (let j = 0; j < groups.length; j += 1) {
                            const group = groups[j];
                            if (group === company.admins) {
                                g.push(this.$tr('Администратор'));
                            } else if (group !== company.staff) {
                                this.$api.get_group(company.id, group, (item) => {
                                    if (item != null) {
                                        g.push(item.name);
                                    }
                                });
                            }
                        }
                    }
                }
            }
            return result;
        },
    },
};
</script>

<style scoped>
.popover-content {
    padding: 8px;
}
</style>
